import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import * as Constants from '../../../../SharedModules/AppConstants';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

// for loading spinner
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  payload: value,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const dispatchSelectType = (data) => ({
  type: ActionTypes.NDC_SELECT_TYPE,
  payload: data,
});

// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: ActionTypes.GET_REBATE_PROGRAM_NDC_HISTORY,
  payload: data,
});

//Action to clear the store once report tab is closed
export const refreshNDCHistory = () => ({
  type: ActionTypes.REFRESH_NDC_HISTORY,
  payload: {},
});
export const refreshNDCHistoryDisplay = () => ({
  type: ActionTypes.REFRESH_NDC_HISTORY_DISPLAY,
  payload: {},
});
//  error msg dispatch function
export const dispatchErrorMsgNDCDetails = (data) => ({
  type: ActionTypes.GET_ERROR_MSG_NDC_DETAILS,
  payload: data,
});

//Action to set the store on search click of request screen
export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT_NDC_HISTORY,
  payload: data,
});

//For Quarter validation
export const handleErrorMesGenerateInvInRedux = (data) => ({
  type: ActionTypes.HANDLE_ERROR_MESSAGE_FOR_G_INV,
  errorMessagesInRedux: data,
});
export const dispatchErrorMsgNDCDetail = (data) => ({
  type: ActionTypes.GET_ERROR_MSG_NDC_DETAILS,
  payload: data,
});

// set the setNDCHistoryData data for display screen
export const setExportAllData = (data, key) => ({
  type: ActionTypes.SET_NDC_HISTORY_REPORT_DATA_ALL,
  payload: data,
  key,
});

// set the setNDCHistoryData data for display screen
export const setNDCHistoryData = (data) => ({
  type: ActionTypes.SET_NDC_HISTORY_REPORT_DATA,
  payload: data,
});

export const setNDCHistoryDisputeCodesData = (data) => ({
  type: ActionTypes.SET_NDC_HISTORY_DISPUTE_CODE_DATA,
  payload: data,
});

//To set state of Modal of NO Data Found
export const setOpenModal = (data) => ({
  type: ActionTypes.SET_OPEN_MODAL,
  payload: data,
});

//to retain pagination undex
export const setPaginationIndex = (value) => ({
  type: ActionTypes.SET_PAGINATION_INDEX_NDC_HISTORY,
  payload: value,
});

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
    // dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};
// To get plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};

//  get rebate programe Dropdown
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data.data;
    })
    .catch((response) => {});
};

export const ndcHistoryDetailDisp = (payload) => ({
  type: ActionTypes.NDC_HIST_DETAIL_DISP,
  payload,
});

//API call to get the NDC details grid data
export const getndchistorygrid = (value) => (dispatch) => {
  dispatch(setLoading(true));
  // dispatch(setOpenModal(false));
  return axios
    .post(`${serviceEndPoint.GET_NDC_HISTORY_GRID}`, value)
    .then((response) => {
      dispatch(setLoading(false));
      if (
        response?.data?.contractDetailsVO &&
        response?.data?.contractDetailsVO.length > 0
      ) {
        dispatch(
          dispatch(setNDCHistoryData(response?.data?.contractDetailsVO))
        );
        return response?.data?.contractDetailsVO;
      } else {
        dispatch(showNoDataMessage());
        // dispatch(setOpenModal(true));
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setNDCHistoryData([]));
    });
};

//API call to get the NDC details grid data
export const getndchistorydisputecode = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_NDC_HISTORY_DISPUTE_CODES}`, value)
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(
        setNDCHistoryDisputeCodesData(
          response?.data?.ndcHistoryDisputeCodeVO || []
        )
      );
      return response?.data?.ndcHistoryDisputeCodeVO || [];
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setNDCHistoryDisputeCodesData([]));
    });
};

//API call to get the labeler data
export const getLabelerList = async (values) => {
  try {
    const response = await axios.get(
      serviceEndPoint.GET_ALL_LABELER_LIST,
      values
    );
    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data.data;
      // eslint-disable-next-line no-else-return
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};

//API call to get the NDC details grid data
export const getndchistorygridForExportAllData = (value, i) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_NDC_HISTORY_GRID}`, value)
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(setExportAllData(response?.data?.contractDetailsVO, i));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setExportAllData([], 'noData'));
    });
};
export const getndchistorygridForExportAll =
  (value, drugSeqNumArr) => (dispatch) => {
    for (let i = 0; i < drugSeqNumArr.length; i++) {
      const values = {
        ...value,
        drugSeqNum: drugSeqNumArr[i],
      };
      dispatch(getndchistorygridForExportAllData(values, i));
    }
  };
